<template>
  <div>

    <DxDataGrid
      :columns="itemHeaders"
      :summary="summary"
      :data-source="lineItems.data"
      :show-borders="true"
      :allow-column-resizing="true"
      :showRowLines="true"
      key-expr="id"
      format="dd/MM/yyyy"
      :toolbar="toolbar"
      @cell-prepared="onCellPrepared"
      @focused-row-changing="onFocusedRowChanging"
      @focused-row-changed="onFocusedRowChanged"
      @cell-value-changed="onCellValueChanged"
      @option-changed="onOptionChanged"
      @key-down="onOptionChanged"
      @editing-start="onEditingStart"
      :ref="itemDataGridRefKey"
    >
      <DxEditing
        :allow-updating="true"
        :allow-deleting="true"
        mode="batch"
        :select-text-on-edit-start="true"
        :new-row-position="newRowPosition"
        :use-icons="true"
        start-edit-action="click"
      />
      <template #cstm-field="{ data: cellData }">
        <div>
          <custom-field-types-list
            :item="cellData"
            :on-value-changed="cellData.setValue"
            :prefix="slug"
            :fieldDef="itemHeaders[cellData.columnIndex]"
            @calculation-field-changed="handleCalculationFieldChange"
          >
          </custom-field-types-list>
        </div>
      </template>
      <template #rlt-field-show="{ data: cellData }">
        <div>
          <relate-show
            :cellData="cellData"
            :prefix="slug"
            :currentRoute="cellData.columnIndex"
            :fieldDef="itemHeaders[cellData.columnIndex]"
          >
          </relate-show>
        </div>
      </template>
    </DxDataGrid>

    <div class="grid grid-cols-2 gap-4">
      <div class="line-add-button">
        <DxButton
          text="Add"
          type="normal"
          icon="plus"
          styling-mode="contained"
          @click="addNewRow()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { DxDataGrid, DxColumn, DxEditing } from "devextreme-vue/data-grid";
import CustomFieldTypesList from "./CustomFieldTypesforList.vue";
import RelateShow from "./line_item/ListRelateFieldShow.vue";
import DxButton from "devextreme-vue/button";
import DxDateBox from "devextreme-vue/date-box";
import CustomStore from "devextreme/data/custom_store";
import { isProxy, isArrayProxy, isProxy1 } from "./builder/base.js";

const ledgerDataGridRefKey = "ledgerDataGrid";

let sTotal = 0;

export default {
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    def: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    fname: String,
    isBatchDetail: Boolean,
    slug: String,
    modRoute: String,
  },
  components: {
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxButton,
    DxDateBox,
    CustomFieldTypesList,
    RelateShow,
  },
  data: function () {
    return {
      itemDataGridRefKey: this.fname + "grid",
      ledgerDataGridRefKey,
      productRoute: "cnsl-products",
      sTotal,
      newRowPosition: "last",
      lineItems: { data: [] },
      items: [],
      itemHeaders: [],
      data: null,
      focusedRowKey: null,
      summary: {
        recalculateWhileEditing: true,
        totalItems: [
          {
            column: "Amount",
            summaryType: "sum",
            displayFormat: "Total: {0}",
          },
        ],
      },
      toolbar: {
        visible: false,
      },
      pendingChanges: false,
    };
  },
  methods: {
    handleCalculationFieldChange(changeData) {
      // Find the row index based on the data or ID
      const rowIndex = this.lineItems.data.findIndex(
        (item) =>
          item.id === changeData.rowData.id || item === changeData.rowData
      );

      if (rowIndex >= 0) {
        // Update the field in our data
        this.lineItems.data[rowIndex][changeData.field] = changeData.value;

        // Trigger recalculation for this row
        this.recalculateAmount(rowIndex);
      }
    },
    recalculateAmount(rowIndex) {
     /*  if (this.lineItems.data[rowIndex]) {
        const rowData = this.lineItems.data[rowIndex];
        const billedQty = parseFloat(rowData.billed_qty) || 0;
        const rate = parseFloat(rowData.rate) || 0;
        const discount = parseFloat(rowData.discount) || 0;

        // Calculate the new amount
        const calculatedAmount =
          billedQty * rate - ((rate * billedQty) / 100) * discount;

        // Update the amount in the row data
        rowData.amount = calculatedAmount;

        // Create a deep copy of the lineItems to trigger reactivity
        this.lineItems = {
          data: JSON.parse(JSON.stringify(this.lineItems.data)),
        };

        // Update the data property
        this.data = { ...this.lineItems };

        // Emit the updated values
        this.$emit("update:modelValue", this.lineItems);

        console.log(
          "Amount recalculated for row",
          rowIndex,
          ":",
          calculatedAmount
        );

        // Force a refresh of the grid
        if (this.itemDataGrid) {
          this.$nextTick(() => {
            this.itemDataGrid.refresh(true);
          });
        }
      } */
    },
    beforeUnmount() {
      // Remove the event listener
      this.removeOutsideClickListener();
    },

    setupOutsideClickListener() {
      // Store reference to component instance
      const self = this;

      // Function to handle document clicks
      this.handleOutsideClick = function (event) {
        // Get reference to the DataGrid element
        const dataGridElement = self.$refs[self.itemDataGridRefKey].$el;

        // Check if the click was outside the DataGrid
        if (dataGridElement && !dataGridElement.contains(event.target)) {
          // If there are pending changes, save them
          if (self.itemDataGrid && self.itemDataGrid.hasEditData()) {
            self.save();
            self.$emit("update:modelValue", self.lineItems);
            console.log("Outside click detected, data saved and emitted");
          }
        }
      };

      // Add global click event listener
      document.addEventListener("click", this.handleOutsideClick);
    },

    removeOutsideClickListener() {
      // Clean up the event listener when component is destroyed
      document.removeEventListener("click", this.handleOutsideClick);
    },

    onFocusedRowChanging(e) {
      const rowsCount = e.component.getVisibleRows().length;
      const pageCount = e.component.pageCount ? e.component.pageCount() : 1;
      const pageIndex = e.component.pageIndex ? e.component.pageIndex() : 0;
      const key = (e.event ? e.event : {}).key;

      if (key && e.prevRowIndex === e.newRowIndex) {
        if (e.newRowIndex === rowsCount - 1 && pageIndex < pageCount - 1) {
          e.component.pageIndex(pageIndex + 1).then(() => {
            e.component.option("focusedRowIndex", 0);
          });
        } else if (e.newRowIndex === 0 && pageIndex > 0) {
          e.component.pageIndex(pageIndex - 1).then(() => {
            e.component.option("focusedRowIndex", rowsCount - 1);
          });
        }
      }
    },

    onFocusedRowChanged(e) {
      // Check if e.row exists and has a key property before accessing it
      if (e && e.row && e.row.key !== undefined) {
        this.focusedRowKey = e.row.key;
      } else if (e && e.component && e.component.option) {
        // Try to get the focused row key from the component
        const focusedRowKey = e.component.option("focusedRowKey");
        if (focusedRowKey !== undefined) {
          this.focusedRowKey = focusedRowKey;
        }
      }
      console.log("Row changed", e);
    },

    // Handle cell edit ending event
    onCellEditEnding(e) {
      console.log("Cell edit ending", e);
      this.pendingChanges = true;

      // Validate the current row being edited
      const currentRowData = e.component.getVisibleRows()[e.rowIndex].data;
      const isValid = this.validateRow(currentRowData);

      console.log("Current row valid:", isValid);
    },

    // Handle row updating event (before update)
    onRowUpdating(e) {
      console.log("Row updating", e);
      this.pendingChanges = true;
    },

    // Handle row updated event (after update)
    onRowUpdated(e) {
      console.log("Row updated", e);

      // Check if all rows are valid before saving
      this.save();
      this.$emit("update:modelValue", this.lineItems);
      console.log("All rows valid, data emitted");
    },

    onKeyDown(e) {
      if (e.event.keyCode === 9) {
        // Tab key
        this.pendingChanges = true;

        // Get the current edited row
        const rowIndex = e.component.option("focusedRowIndex");
        if (rowIndex >= 0) {
          const rowData = e.component.getVisibleRows()[rowIndex].data;
          const isValid = this.validateRow(rowData);
          console.log("Tab pressed, current row valid:", isValid);
        }
      }
    },

    onCellClick(e) {
      this.save();
      console.log("Cell clicked", e);
      // Start editing on first click
      if (e.rowType === "data" && e.column.allowEditing) {
        e.component.editCell(e.rowIndex, e.columnIndex);
      }
    },

    onOptionChanged(e) {
      console.log("Option changed", e);

      if (this.pendingChanges) {
        // Only save and emit if all rows are valid
        this.save();
        this.$emit("update:modelValue", this.lineItems);
        console.log("Option changed, all rows valid, data emitted");
        this.pendingChanges = false;
      }
    },

    grandchildMethod() {
      console.log("Method in grandchild component called!");
      this.save();
      this.$emit("update:modelValue", this.lineItems);
      console.log("Grandchild method, all rows valid, data emitted");
    },

    addNewRow() {
      this.itemDataGrid.addRow();
    },

    save(e) {
      console.log("Called save method", e);
      if (this.itemDataGrid && this.itemDataGrid.hasEditData()) {
        this.itemDataGrid.saveEditData();
        console.log("Data saved successfully", this.fname);
        this.data = this.lineItems;

        // Update the data display after saving
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      }
    },

    onFocusCellChanged(e) {
      this.data = this.lineItems;
      if (e && e.rowType === "data" && e.column && e.column.allowEditing) {
        e.component.editCell(e.rowIndex, e.columnIndex);
      }

      if (this.pendingChanges && this.itemDataGrid.hasEditData()) {
        // Only save and emit if all rows are valid
        this.save();
        this.$emit("update:modelValue", this.lineItems);
        console.log("Focus changed, all rows valid, data emitted");
        this.pendingChanges = false;
      }
    },

    handleCellClick(e) {
      console.log("clicked: ", e);
      if (
        e.column.editorType == "dxSelectBox" &&
        e.column.editCellTemplate != "cstm-field"
      ) {
        console.log(" handleCellClick Cell selectbox hai: ", e.column);
        e.cellElement.addEventListener("change", (event) => {
          this.pendingChanges = true;
        });
      }
    },

    onCellPrepared(e) {
      console.log("onCellPrepared EValue", e);

      if (e.rowType === "data" && e.column.allowEditing) {
        if (
          e.column.dataField == "cnsl_product_id" ||
          e.column.dataField == "product_id"
        ) {
          if (e.value !== null && e.value !== undefined && e.value !== "")  {
            if (e.column.dataField == "product_id") {
              this.productRoute = "products";
            }
            let url =
              "/" + this.slug + "/" + this.productRoute + "/getById/" + e.value;
            return axios
              .get(url)
              .then((response) => {
                //console.log("Product response", response.data.data);
                console.log("FIELD LINE ITEM ", this.lineItems);
                if (this.lineItems.data.length != 0) {
                  this.lineItems.data[e.rowIndex].hsn = response.data.data.hsn;
                  this.lineItems.data[e.rowIndex].gst_rate =
                    response.data.data.gst_rate;

                  // Recalculate amount when product changes
                  this.recalculateAmount(e.rowIndex);
                }
              })
              .catch((error) => {
                console.error("Error fetching dependent value:", error);
                throw error;
              });
          }
        }

        e.cellElement.addEventListener("change", (event) => {
          console.log("onCellPrepared EValue phle = ", this.lineItems);
          this.pendingChanges = true;
        });
      }
    },

    addDataSourceInList(data, slug) {
      console.log("addDataSourceInList DATA", this.data);

      const modifiedData = data.map((column) => {
        console.log("column", column);
        // Make amount column read-only and add calculation logic
      
        // Process other columns as before
        if (column.editorType === "dxSelectBox" && !column.lookup) {
          return {
            ...column,
            editorType: column.editorType,
            editorOptions: column.editorOptions,
            lookup: {
              dataSource: this.makeAsyncDataSource(
                column.editorOptions.relateModule,
                slug
              ),
              valueExpr: "id",
              displayExpr: "name",
            },
          };
        }

        return column;
      });

      return modifiedData;
    },

    // Helper method to recalculate amount for a specific row
    // recalculateAmount(rowIndex) {
    //   if (this.lineItems.data[rowIndex]) {
    //     const rowData = this.lineItems.data[rowIndex];
    //     const billedQty = parseFloat(rowData.billed_qty) || 0;
    //     const rate = parseFloat(rowData.rate) || 0;
    //     const discount = parseFloat(rowData.discount) || 0;

    //     // Calculate the new amount
    //     const calculatedAmount = billedQty * rate - ((rate * billedQty) / 100) * discount;

    //     // Update the amount in the row data
    //     rowData.amount = calculatedAmount;

    //     // Update the data property to display the new values
    //     this.data = { ...this.lineItems };

    //     // Emit the updated values
    //     this.$emit("update:modelValue", this.lineItems);

    //     console.log("Amount recalculated for row", rowIndex, ":", calculatedAmount);

    //     // Force a refresh of the grid
    //     if (this.itemDataGrid) {
    //       this.itemDataGrid.refresh(true);
    //     }
    //   }
    // },

    onCellValueChanged(e) {
      console.log("Cell value changed:", e);

      // Force recalculation when related fields change
      if (["billed_qty", "rate", "discount"].includes(e.column.dataField)) {
        const rowIndex = e.rowIndex;

        // Store the updated value
        this.lineItems.data[rowIndex][e.column.dataField] = e.value;

        // Trigger recalculation for this row
        this.recalculateAmount(rowIndex);
      }
    },

    makeAsyncDataSource(rRoute, slug) {
      return new CustomStore({
        key: "id",
        load: function (loadOptions) {
          let listurl = "/" + slug + "/" + rRoute + "/list";
          var parameters = {};
          var tFilter = [
            loadOptions.searchExpr,
            loadOptions.searchOperation,
            loadOptions.searchValue,
          ];

          if (loadOptions.sort) {
            parameters.order_column = loadOptions.sort[0].selector;
            if (loadOptions.sort[0].desc) parameters.order_direction = "asc";
          }
          if (
            loadOptions.searchExpr != null &&
            loadOptions.searchValue != null
          ) {
            parameters.filter = JSON.stringify(tFilter);
          }

          var config = {
            params: parameters,
          };
          return axios
            .get(listurl, config)
            .then((response) => {
              console.log("mytry", response.data.results.data);
              return {
                data: response.data.results.data,
                totalCount: response.data.results.total,
              };
            })
            .catch(() => {
              throw "Data Loading Error";
            });
        },
        byKey: function (key) {

          
          console.log("ByKey Call hua" + key);
          let url = "/" + slug + "/" + rRoute + "/getById/" + key;
          // Implementation needed
        },
      });
    },

    refreshDataGrid() {
      console.log("refresh datagrid");
      if (this.itemDataGrid) {
        this.itemDataGrid
          .refresh(true)
          .then(function () {})
          .catch(function (error) {});
      }
    },

    setColumnDefs() {
      var serialDefs = [
        {
          width: 30,
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(cellInfo.row.rowIndex);
          },
        },
      ];

      var columnDefs = serialDefs.concat(this.itemHeaders);
      return columnDefs;
    },
  },

  created: function () {},

  mounted() {
    console.log("Line Item Component Mounted", this.def);
    this.itemHeaders = this.addDataSourceInList(this.def.line_items, this.slug);

    this.setupOutsideClickListener();
    if (
      (typeof this.modelValue === "object" &&
        Object.keys(this.modelValue).length != 0) ||
      isProxy(this.modelValue)
    ) {
      if (this.isBatchDetail) {
        this.lineItems.data = this.modelValue;
      } else {
        this.lineItems.data = this.modelValue.data;
      }

      console.log("Line Item Component Model Value ", this.modelValue);

      // Initialize 'data' property with lineItems to ensure displaying values
      this.data = { ...this.lineItems };
    }

    if (Object.keys(this.modelValue).length === 0) {
      //set blank first row only if its create view
      this.$nextTick(() => {
        this.addNewRow();
      });
    }
  },

  computed: {
    itemDataGrid: function () {
      return this.$refs[this.itemDataGridRefKey]?.instance;
    },
  },

  watch: {
    // Watch for changes in the lineItems.data array
    "lineItems.data": {
      deep: true,
      handler(newVal) {
        console.log("lineItems.data changed:", newVal);
        // Update this.data to ensure it's displayed
        this.data = { ...this.lineItems };
      },
    },
  },
};
</script>